/*
====================================================================
                Clase RestablecerContraseñaEntity
====================================================================
Esta clase representa una entidad para manejar la lógica relacionada 
con el restablecimiento de la contraseña. Incluye propiedades para 
almacenar el correo electrónico del usuario y métodos para validar 
la estructura del correo electrónico.

====================================================================
*/

// ------------------------------------------------------------------
//                       DEFINICIÓN DE LA CLASE
// ------------------------------------------------------------------
/**
 * Clase que representa una entidad de restablecimiento de contraseña.
 * 
 * Esta clase encapsula los datos necesarios para solicitar un 
 * restablecimiento de contraseña y proporciona métodos para validar 
 * el formato del correo electrónico.
 */
class RestablecerContraseñaEntity {
  /**
   * Constructor de la clase RestablecerContraseñaEntity.
   * 
   * @param {string} correo - Correo electrónico del usuario.
   */
  constructor(correo = "") {
    this.correo = correo.trim();
  }

  /**
   * Método para validar el formato del correo electrónico.
   * 
   * Utiliza una expresión regular para comprobar si el correo electrónico 
   * tiene un formato válido.
   * 
   * @returns {boolean} `true` si el correo es válido, de lo contrario `false`.
   */
  validarEmail() {
    const patron = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return patron.test(this.correo);
  }

  /**
   * Método para validar que los campos no estén vacíos y el correo tenga una estructura válida.
   * 
   * @returns {string[]} Un array de mensajes de error, si los hay.
   */
  validar() {
    const errores = [];

    // Validar que el correo no esté vacío
    if (!this.correo) {
      errores.push("El correo electrónico no puede estar vacío.");
    } else if (!this.validarEmail()) {
      // Validar que el correo tenga una estructura válida
      errores.push("El correo electrónico no tiene un formato válido.");
    }

    return errores;
  }
}

export default RestablecerContraseñaEntity;
